<template>
  <div class="line">
    <div class="line-box clear">
      <div
        v-for="(line, index) in lineList"
        :key="index"
        class="line-item-box clear"
      >
        <div v-for="(item, index) in line" :key="index" class="line-item">
          <div @click="jumpToSight(item.linkId)" class="line-head">
            <img :src="item.headImg" alt="headImg" />
            <div class="v-line-desc text-overflow">
              {{ item.desc }}
            </div>
          </div>
          <div v-maidian="'line_' + index" class="line-btm clear">
            <div @click="jumpToSight(item.linkId)" class="price">
              <span class="price-ticket">{{item.price}}</span>
              <mt-button size="small"
                >立即预订</mt-button
              >
            </div>
          </div>
        </div>
        <div class="bg-line"></div>
      </div>
    </div>
    <!-- <img class="tip"
      src="https://s.qunarzz.com/srmweb/qunaradv/changma202203/29.png"
      alt=""
    /> -->
  </div>
</template>
<script>
import giftDialog from './dialog/gift/gift';
export default {
  data() {
    return {
      discount: false,
      lineList: [
        [
          {
            headImg:
              'https://img1.qunarzz.com/vs_ceph_b2c_001/990336c6-99f9-40ca-af7d-666ae225d1d1.jpg_r_640x420x95_0e99ed7e.jpg',
            desc: '自由行 【怕晕车用白云山晕动片】升级1晚亚特兰蒂斯海景房🏄畅玩水世界、水乐园+大东海哈曼3晚🏊打卡网红无边泳池',
            note: 0,
            price:2015,
            code: 'SY',
            linkId: 'https://touch.dujia.qunar.com/p/item/566592175',
          },
          {
            headImg:
              'https://img1.qunarzz.com/vs_ceph_b2c_001/ff86a30d-ac96-4a3f-9464-a4327f2d326e.jpg_r_640x420x95_4c73ad22.jpg',
            desc: '【跟团游】【怕晕车用白云山晕动片】丽江+大理+香格里拉6日✨普达措+壮丽虎跳峡+玉龙雪山冰川大索+梦回南诏+双廊+喜洲小马车',
            note: 0,
            price:2339,
            code: 'XGLLG',
            linkId: 'https://qnee9.package.qunar.com/user/detail.jsp?abt=a&id=181882316&',
          },
        ],
      ],
    };
  },
  mounted() {
    this.allVote();
    // giftDialog({});
  },
  methods: {
    jumpToSight(linkId) {
      location.href = linkId;
    },
    allVote() {
      this.commonAjax({
        url: '/commonly/allVote',
        method: 'get',
        success: (data) => {
          this.lineList[0].forEach((item) => {
            data.forEach((child) => {
              if (item.code == child.categoryCode) {
                item.note = child.voteCount;
              }
            });
          });
        },
      });
    },
    userVote(categoryCode) {
      this.commonAjax({
        url: '/commonly/userVote?categoryCode=' + categoryCode,
        method: 'get',
        success: (data) => {
          this.commonAjax({
            url: '/commonly/v2/lottery',
            method: 'post',
            success: (data) => {
              giftDialog({
                giftTip: data.code,
              });
            },
          });
          this.allVote();
        },
      });
    },
  },
};
</script>
<style lang='less' scoped='true'>
.line {
  position: relative;
  top: -36px;
  &-tit {
    width: 100%;
  }
}
.rem(@name,@px) {
  @{name}: unit(@px / 37.5, rem);
}
.line {
  position: relative;
  padding-top: 21px;
  &-box {
    margin-top: 10px;
    margin-left: auto;
    margin-right: auto;
    width: calc(100% - 24px);
    box-sizing: border-box;
    border-radius: 3px;
    background-color: #fff;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
    border-radius: 10px;
    position: relative;
    // &:after {
    //   content: '';
    //   display: block;
    //   width: 190px;
    //   height: 234px;

    //   background: url(https://source.qunarzz.com/site/images/wns/20230414-shijianchen-right.png)
    //     no-repeat;
    //   background-size: 100% auto;
    //   position: absolute;
    //   right: -18px;
    //   bottom: -18px;
    // }
  }
  &-item {
    overflow: hidden;
    position: relative;
    border-radius: 4px;
    width: 100%;
    background-color: #fff;
    float: left;
    z-index: 2;
    padding-top: 0;
    padding-bottom: 30px;
    box-sizing: border-box;
    &:first-child{
      padding-top: 20px;
    }
    &-box {
      position: relative;
      margin-bottom: 7px;
      &:last-child {
        margin-bottom: 0;
      }
      // .bg-line {
      //     background: url(https://picbed.qunarzz.com/f85c6e94de1f40c4bae5c5a5c7261be5.png)
      //         no-repeat;
      //     background-size: 100% auto;
      //     height: 20px;
      //     width: 100%;
      //     position: absolute;
      //     left: 0;
      //     bottom: 7px;
      // }
    }
    &:nth-child(2n + 2) {
      float: right;
    }
  }
  &-desc {
    height: 32px;
    font-size: 14px;
    line-height: 16px;
    margin-bottom: 5px;
    text-align: left;
  }
  &-tag {
    padding-left: 2px;
    padding-right: 2px;
    padding-top: 3px;
    padding-bottom: 3px;
    border: 0.1em solid #ff414c;
    border-radius: 2px;
    color: #ff414c;
    font-size: 9px;
    float: left;
    margin-right: 5px;
  }
  &-cont {
    padding: 7px;
    padding-top: 2px;
    padding-bottom: 0;
  }
  &-btm {
    background: url(https://source.qunarzz.com/site/images/wns/20230423-shijianchen-gy-btn1.png)
      no-repeat;
    background-size: 100% 100%;
    width: 305px;
    height: 42px;
    box-sizing: border-box;
    display: flex;
    margin:0 auto;
    margin-top: 15px;
    align-items: center;
    .price {
      width: 100%;
      &-ticket {
        height: 19px;
        line-height: 19px;
        text-align: left;
        font-size: 16px;
        font-weight: bold;
        float: left;
        color: #D94F40;
        font-size: 18px;
        position: relative;
        text-align: center;
        width: 160px;
        &:before{
          content:"¥";
          font-size: 12px;
        }
        &:after{
          content:"起/人";
          font-size: 12px;
        }
      }
      button {
        position: relative;
        float: right;
        width: 145px;
      }
    }
  }
  &-head {
    height: 100px;
    img {
      display: block;
      width: 150px;
      float: left;
    }
  }
  .price {
    display: flex;
    align-items: center;
  }
  /deep/ .mint-button--small {
    border-radius: 0;
    background-color: transparent;
    border-radius: 6px;
    color: #fff;
    font-size: 13px;
    height: 24px;
    margin-left: auto;
    border:none;
    box-shadow: none;
    &:after{
      content:unset;
    }
  }
  .line-anchor {
    position: absolute;
    left: 0;
    top: 0;
    height: 18px;
    color: #fff;
    font-style: italic;
    text-align: center;
    letter-spacing: 3px;
    background: rgba(255, 63, 79, 1);
    border-radius: 3px 0px 3px 0px;
  }
}
.line-cont {
  padding: 8px 0;
}
.line-cont-desc {
  font-size: 11px;
  color: #666;
  text-align: left;
  margin-top: 4px;
}
.v-line-desc {
  text-align: left;
  // height: 40px;
  font-size: 15px;
  padding-left: 15px;
  box-sizing: border-box;
  font-size: 13px;
  color: #3d3d3d;
  font-weight: bold;
}
.text-overflow {
  -webkit-line-clamp: 4;
}
.tip {
  width: 280px;
  display: block;
  margin: 0 auto;
}
</style>